/* Industrialsafety-UK smart stock search - header dropdown. Needs isu-search-core.js. 2-10-2026 */
(function () {
  'use strict';
  var S = window.ISUS;
  if (!S) return;
  var form = document.querySelector('[data-isu-search]');
  if (!form) return;
  var input = form.querySelector('input[name="q"]');
  var clearBtn = form.querySelector('[data-isu-sclear]');
  var backBtn = form.querySelector('[data-isu-sback]');
  var mq = window.matchMedia('(max-width: 749px)');
  var TRY = ['bronze flat 2 x 1/4', 'pb1 round 1.1/2"', 'ali flat 100x8', '304 tube 25.4', 'copper 50x6', 'aluminum angle 63'];
  var panel = document.createElement('div');
  panel.className = 'isu isu-sp';
  panel.id = 'isu-sp';
  panel.hidden = true;
  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-label', 'Search suggestions');
  var shade = document.createElement('div');
  shade.className = 'isu-sp-shade';
  shade.hidden = true;
  document.body.appendChild(shade);
  document.body.appendChild(panel);
  input.setAttribute('aria-controls', 'isu-sp');
  input.setAttribute('aria-expanded', 'false');

  var open = false, timer = 0, data = null, unit = S.unit(), last = null, active = -1, rowsByKey = {};
  var e = S.esc;

  function place() {
    var r = form.getBoundingClientRect();
    if (mq.matches) { panel.style.cssText = 'top:' + Math.max(0, r.bottom + 6) + 'px'; return; }
    var vw = document.documentElement.clientWidth;
    var left = Math.max(16, r.left - 70), width = Math.min(1400, vw - left - 16);
    if (width < 640) { left = 16; width = vw - 32; }
    panel.style.top = (r.bottom + 10) + 'px';
    panel.style.left = left + 'px';
    panel.style.width = width + 'px';
    panel.style.maxHeight = (window.innerHeight - r.bottom - 26) + 'px';
    shade.style.top = (r.bottom + 4) + 'px';
  }
  function show() {
    if (!open) {
      if (mq.matches && form.getBoundingClientRect().top < 0) form.scrollIntoView({ block: 'start' });
      open = true;
      panel.hidden = false; shade.hidden = false;
      document.documentElement.classList.add('isu-sopen');
      input.setAttribute('aria-expanded', 'true');
    }
    place();
  }
  function hide() {
    if (!open) return;
    open = false;
    panel.hidden = true; shade.hidden = true;
    document.documentElement.classList.remove('isu-sopen');
    input.setAttribute('aria-expanded', 'false');
    active = -1;
  }
  function ensure() {
    if (data) return Promise.resolve(data);
    return S.load().then(function (d) { data = d; return d; });
  }

  function swatch(p) {
    var c = p.mat ? p.mat.c : '#c8ced6', k = p.prof ? p.prof.k : 'flat', sh;
    if (k === 'round' || k === 'tube') sh = '<span class="isu-ssw__c" style="border-color:' + c + ';' + (k === 'round' ? 'background:' + c : '') + '"></span>';
    else if (k === 'angle') sh = '<span class="isu-ssw__l" style="border-color:' + c + '"></span>';
    else if (k === 'sheet') sh = '<span class="isu-ssw__s" style="background:' + c + '"></span>';
    else if (k === 'box' || k === 'square') sh = '<span class="isu-ssw__b" style="border-color:' + c + ';' + (k === 'square' ? 'background:' + c : '') + '"></span>';
    else sh = '<span class="isu-ssw__f" style="background:' + c + '"></span>';
    return '<span class="isu-ssw" aria-hidden="true">' + sh + '</span>';
  }
  function buy(p, compact) {
    if (!p.av) return '<a class="isu-sbtn isu-sbtn--ghost" href="/products/' + p.h + '" tabindex="-1">View</a>';
    if (p.varies || p.vc > 1) return '<a class="isu-sbtn isu-sbtn--ghost" href="/products/' + p.h + '" tabindex="-1">' + (compact ? '<span class="isu-sr">Options for ' + e(p.name) + '</span>›' : 'Options') + '</a>';
    return '<button type="button" class="isu-sbtn" data-add="' + p.id + '" tabindex="-1">' + (compact ? '<span class="isu-sr">Add ' + e(p.name) + '</span>+' : 'Add') + '</button>';
  }
  function row(p) {
    rowsByKey[p.id] = p;
    var sz = S.size(p, unit), alt = S.altSize(p, unit), compact = mq.matches;
    return '<div class="isu-sr-row" data-row="' + p.id + '">' + swatch(p) +
      '<div class="isu-sr-row__m"><a class="isu-sr-row__t" data-nav href="/products/' + p.h + '" title="' + e(p.t) + '">' + e(p.name) + '</a>' +
      '<div class="isu-sr-row__d">' + (sz ? '<span class="isu-chip-size">' + e(sz) + '</span>' : '') +
      (alt && !compact ? '<span>' + e(alt) + '</span>' : '') +
      (p.kg ? '<span>' + (alt && !compact ? '· ' : '') + p.kg.toFixed(2) + ' kg/m</span>' : '') + '</div>' +
      (compact ? '<div class="isu-sr-row__pm">' + (p.varies ? '<small>from</small> ' : '') + S.money(p.price) + '</div>' : '') + '</div>' +
      (compact ? '' : '<div class="isu-sr-row__p">' + (p.varies ? '<small>from</small> ' : '') + S.money(p.price) + '</div>') +
      buy(p, compact) + '</div>';
  }
  function group(title, sub, list) {
    if (!list.length) return '';
    return '<section class="isu-sp__g"><h3>' + e(title) + (sub ? ' <span>' + e(sub) + '</span>' : '') + '</h3>' + list.map(row).join('') + '</section>';
  }
  function chips(pq) {
    var c = [];
    if (pq.mat) c.push(['mat', 'Material', pq.mat.n]);
    if (pq.grade) c.push(['grade', 'Grade', pq.grade]);
    if (pq.prof) c.push(['prof', 'Profile', pq.prof.n]);
    if (pq.dims.length) c.push(['dims', 'Size', pq.dims.map(function (d) { return unit === 'in' ? S.inch(d) : S.trim(d); }).join(' × ') + (unit === 'in' ? '' : ' mm')]);
    if (!c.length) return '';
    return '<div class="isu-sp__read"><span class="isu-sp__lbl">We read this as</span>' + c.map(function (x) {
      return '<button type="button" class="isu-rchip" data-drop="' + x[0] + '"><span class="isu-rchip__k">' + x[1] + '</span> <b>' + e(x[2]) + '</b><span class="isu-rchip__x" aria-hidden="true">×</span><span class="isu-sr">Remove ' + x[1] + '</span></button>';
    }).join('') + '</div>';
  }
  function units() {
    return '<div class="isu-unit" role="group" aria-label="Show sizes in"><span class="isu-sp__lbl">Show sizes in</span>' +
      '<button type="button" data-unit="mm" aria-pressed="' + (unit === 'mm') + '">mm</button><button type="button" data-unit="in" aria-pressed="' + (unit === 'in') + '">' + (mq.matches ? 'in' : 'inch') + '</button></div>';
  }
  function cats(list) {
    var m = {}, order = [];
    list.forEach(function (p) {
      if (!p.mat || !p.prof) return;
      var k = p.mat.k + '|' + p.prof.k;
      if (!m[k]) { m[k] = { n: p.mat.n + ' ' + p.prof.n.toLowerCase(), c: 0 }; order.push(k); }
      m[k].c++;
    });
    order.sort(function (a, b) { return m[b].c - m[a].c; });
    return order.slice(0, 5).map(function (k) {
      return '<a class="isu-cat" data-nav href="/search?type=product&q=' + encodeURIComponent(m[k].n) + '"><span>' + e(m[k].n) + '</span><span>' + m[k].c + ' size' + (m[k].c === 1 ? '' : 's') + '</span></a>';
    }).join('');
  }
  function side(list) {
    var c = list && list.length ? cats(list) : '';
    return '<aside class="isu-sp__side">' + (c ? '<h3>Categories</h3><div class="isu-cats">' + c + '</div>' : '') +
      '<h3>Try a search</h3><div class="isu-tries">' + TRY.map(function (t) { return '<button type="button" class="isu-try" data-try="' + e(t) + '">' + e(t) + '</button>'; }).join('') + '</div>' +
      '<div class="isu-scut"><strong>Need several sizes?</strong><p>Paste your cut list and we’ll price every line together.</p><a class="isu-scut__btn" href="/#trade-quote">Send a cut list</a></div></aside>';
  }
  function render() {
    var q = input.value.trim();
    clearBtn && (clearBtn.hidden = !q);
    rowsByKey = {};
    active = -1;
    if (!q) {
      panel.innerHTML = '<div class="isu-sp__body isu-sp__body--idle"><div class="isu-sp__main"><section class="isu-sp__g"><h3>Search by size, grade or profile</h3><p class="isu-sp__hint">Type a material and a size in mm or inches — e.g. <b>copper 50 x 6</b> or <b>bronze flat 2 x 1/4</b>.</p></section></div>' + side(null) + '</div>';
      return;
    }
    if (!data) {
      panel.innerHTML = '<div class="isu-sp__body"><div class="isu-sp__main"><p class="isu-sp__load"><span class="isu-spin" aria-hidden="true"></span>Loading the stock list…</p></div></div>';
      ensure().then(render, function () {
        panel.innerHTML = '<div class="isu-sp__body"><div class="isu-sp__main"><p class="isu-sp__load">Press Enter to search “' + e(q) + '”.</p></div></div>';
      });
      return;
    }
    var pq = S.parse(q), r = S.search(data, pq);
    last = { q: q, pq: pq, r: r };
    var total = pq.dims.length ? r.exact.length + r.near.length : r.all.length;
    var main;
    if (pq.dims.length) {
      main = group('Exact size', r.exact.length + ' in stock range' + (r.exact.length === 1 ? '' : 's'), r.exact.slice(0, mq.matches ? 4 : 3)) +
        group('Nearest sizes', 'within 30% of ' + pq.dims.map(function (d) { return S.trim(d); }).join(' × ') + ' mm', r.near.slice(0, mq.matches ? 4 : 3)) +
        group('Same size, other materials', '', r.other.slice(0, 2));
    } else {
      main = group(pq.mat || pq.prof ? 'Matching stock' : 'Products', r.all.length + ' found', r.all.slice(0, 6));
    }
    if (!main) {
      main = '<section class="isu-sp__g isu-sp__none"><h3>No stock match for “' + e(q) + '”</h3><p class="isu-sp__hint">Check the size or try fewer words. We can also source or cut sizes we don’t list.</p><a class="isu-sbtn" href="/#trade-quote">Request this size</a></section>';
    }
    var head = chips(pq) + units();
    panel.innerHTML = '<div class="isu-sp__top">' + head + '</div><div class="isu-sp__body"><div class="isu-sp__main">' + main + '</div>' + (mq.matches ? '' : side(r.all.length ? r.all : base(pq))) + '</div>' +
      (total ? '<a class="isu-sp__all" data-nav href="' + allUrl(q) + '"><span>See all ' + total + ' result' + (total === 1 ? '' : 's') + (mq.matches ? '' : ' for “' + e(q) + '”') + '</span>' + (mq.matches ? '' : '<span class="isu-sp__enter">Enter <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></span>') + '</a>' : '');
  }
  function base(pq) { return S.base(data, { mat: pq.mat, prof: pq.prof, grade: pq.grade, words: [], dims: [] }); }
  function allUrl(q) { return '/search?type=product&q=' + encodeURIComponent(q); }
  function schedule() { clearTimeout(timer); timer = setTimeout(render, 90); }

  function dropPart(k) {
    if (!last) return;
    var pq = last.pq, n = { mat: pq.mat, prof: pq.prof, grade: pq.grade, dims: pq.dims, words: pq.words };
    if (k === 'mat') { n.mat = null; if (n.grade) n.grade = ''; }
    if (k === 'grade') n.grade = '';
    if (k === 'prof') n.prof = null;
    if (k === 'dims') n.dims = [];
    input.value = S.label(n);
    render();
    input.focus();
  }
  function navs() { return Array.prototype.slice.call(panel.querySelectorAll('[data-nav]')); }
  function setActive(i) {
    var n = navs();
    if (!n.length) return;
    active = (i + n.length) % n.length;
    n.forEach(function (a, j) { a.classList.toggle('is-active', j === active); });
    n[active].scrollIntoView({ block: 'nearest' });
  }

  input.addEventListener('focus', function () { show(); ensure().then(function () { if (open) render(); }, function () {}); render(); });
  input.addEventListener('input', function () { show(); schedule(); });
  input.addEventListener('keydown', function (ev) {
    if (ev.key === 'ArrowDown') { ev.preventDefault(); show(); setActive(active + 1); }
    else if (ev.key === 'ArrowUp') { ev.preventDefault(); setActive(active - 1); }
    else if (ev.key === 'Escape') { hide(); }
    else if (ev.key === 'Enter' && active > -1) { var n = navs()[active]; if (n) { ev.preventDefault(); window.location.href = n.href; } }
  });
  clearBtn && clearBtn.addEventListener('click', function () { input.value = ''; render(); input.focus(); });
  backBtn && backBtn.addEventListener('click', function () { hide(); input.blur(); });
  shade.addEventListener('click', hide);
  document.addEventListener('mousedown', function (ev) { if (open && !mq.matches && !panel.contains(ev.target) && !form.contains(ev.target)) hide(); });
  window.addEventListener('resize', function () { if (open) place(); });
  window.addEventListener('scroll', function () { if (open) place(); }, { passive: true });

  panel.addEventListener('click', function (ev) {
    var t = ev.target.closest('button');
    if (!t) return;
    if (t.hasAttribute('data-drop')) dropPart(t.getAttribute('data-drop'));
    else if (t.hasAttribute('data-unit')) { unit = t.getAttribute('data-unit'); S.setUnit(unit); render(); }
    else if (t.hasAttribute('data-try')) { input.value = t.getAttribute('data-try'); render(); input.focus(); }
    else if (t.hasAttribute('data-add')) {
      var p = rowsByKey[t.getAttribute('data-add')];
      if (!p || t.disabled) return;
      t.disabled = true;
      var was = t.innerHTML;
      t.innerHTML = '…';
      S.add(p).then(function () { t.innerHTML = mq.matches ? '✓' : 'Added ✓'; t.classList.add('is-added'); setTimeout(function () { t.innerHTML = was; t.disabled = false; t.classList.remove('is-added'); }, 2200); },
        function () { t.innerHTML = was; t.disabled = false; window.location.href = '/products/' + p.h; });
    }
  });
  form.addEventListener('submit', function () { hide(); });
})();
